module.exports = __webpack_public_path__ + "static/media/sweep.ebc5f0ad.svg";